export const parseDivisionScope = (divisionScope?: string): string | undefined => {
  if (!divisionScope) return divisionScope;

  const lastDashIndex = divisionScope.lastIndexOf("-");
  if (lastDashIndex === -1) return divisionScope;

  const afterDash = divisionScope.substring(lastDashIndex + 1).trim();
  // Check if what's after the dash is exactly 3 alphanumeric characters
  if (afterDash.length === 3 && /^[A-Za-z0-9]{3}$/.test(afterDash)) {
    return divisionScope.substring(0, lastDashIndex).trim();
  }

  return divisionScope;
};
